import { render, staticRenderFns } from "./footers.vue?vue&type=template&id=0fdd7684&scoped=true&"
import script from "./footers.vue?vue&type=script&lang=js&"
export * from "./footers.vue?vue&type=script&lang=js&"
import style0 from "./footers.vue?vue&type=style&index=0&id=0fdd7684&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdd7684",
  null
  
)

export default component.exports